module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/article-5-937f0fdc115caef17c164587d9b4597d.jpg";